import {logger} from 'tizra'
import {GenericStep} from './steps/GenericStep'
import {UmphBillingStep} from './steps/UmphBillingStep'
import {UmphStep} from './steps/UmphStep'
import {StepComponent, StepComponentProps} from './types'

const log = logger('CartBlock/CheckoutStep')

export const decideStepComponent = (
  props: StepComponentProps,
): StepComponent => {
  const {checkout, step} = props
  if (checkout?.name === 'umph') {
    if (step?.name === 'billing-address') {
      return UmphBillingStep
    }
    return UmphStep
  }
  return GenericStep
}

export const CheckoutStep: StepComponent = props => {
  const Component = decideStepComponent(props)
  return <Component {...props} />
}
